<template>
  <div class="v-header">
    <img class="logo" src="https://storage.xiaowugame.com/front/wuyun-app/v1/h5-logo.png" alt />
    <Button @click="logout" class="logout" icon="md-power" ghost></Button>
    <Dropdown class="user-msg" @on-click="toUserEdit">
      <a href="javascript:void(0)">
        <img class="avatar" src="https://storage.xiaowugame.com/upload/game/e4ff4f94213318af9b03eaa3ddf7f057.jpg" alt />
        <span class="user-name">{{ userName }}</span>
        <Icon type="ios-arrow-down"></Icon>
      </a>
      <DropdownMenu slot="list">
        <DropdownItem name="1">修改密码</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
import { Button, Dropdown, DropdownMenu, DropdownItem, Icon } from 'view-design';
export default {
  components: {
    Button,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Icon,
  },
  data() {
    return {
      userName: '',
    };
  },
  created() {
    let name = localStorage.getItem('usermsg');
    if (name) {
      this.userName = name;
    }
  },
  methods: {
    logout() {
      this.$Modal.confirm({
        title: '退出系统确认',
        content: '<p>确定要退出登录吗？</p>',
        onOk: () => {
          localStorage.removeItem('apitoken');
          localStorage.removeItem('usermsg');
          localStorage.removeItem('expireIn');
          this.$router.push('/');
        },
      });
    },
    toUserEdit() {
      this.$router.push('/user/edit');
    },
  },
};
</script>
<style lang="scss">
.v-header {
  width: 100%;
  height: 70px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
  background: #363e4f;
  .logo {
    height: 70px;
  }
  .logout {
    border: none;
    width: 60px;
    height: 70px;
    font-size: 24px;
    float: right;
    &:hover {
      background: #434d62;
    }
  }
  .user-msg {
    float: right;
    height: 70px;
    line-height: 70px;
    padding: 0 10px;
    cursor: pointer;
    a {
      color: #fff;
    }
    &:hover {
      background: #434d62;
      a {
        color: #57a3f3;
      }
    }
  }
  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 5px;
  }
  .user-name {
    font-size: 18px;
  }
}
</style>
